<template>

<div id="app">
	
	<router-view key="$path"></router-view>

</div>

</template>

<script>

export default {
	name: 'App'
}

</script>

<style>

body {
	background-color: #1A4860;
}

#app {
	position: fixed;
	left: 0px;
	top: 0px;
	right: 0px;
	bottom: 0px;
	background-color: #1A4860;
}

</style>
